import { CreateBibleStudySection } from '../api/models/BibleStudySection';
import { BibleStudyFormState } from '../modules/bible-studies/bible-study-form';

const BIBLE_STUDY_FORM_TOKEN = '@bibleStudyForm';

type Payload = {
  study: BibleStudyFormState;
  sections: CreateBibleStudySection[];
};

export type FormAutoSaverService = {
  save: (payload: Payload) => void;
  get: () => Payload;
  clear: () => void;
};

/**
 * Auto-save service for the bible study form
 */
export function autoSaveService(): FormAutoSaverService {
  return {
    save(payload) {
      const existingSave = localStorage.getItem(BIBLE_STUDY_FORM_TOKEN);
      let newPayload = { ...payload };

      if (existingSave) {
        const forms: Payload = JSON.parse(existingSave);
        newPayload = {
          sections: payload.sections,
          // If there is an existing save, join em.
          study: { ...forms.study, ...payload.study },
        };
      }

      localStorage.setItem(BIBLE_STUDY_FORM_TOKEN, JSON.stringify(newPayload));
    },
    get() {
      const item = localStorage.getItem(BIBLE_STUDY_FORM_TOKEN);
      if (!item) {
        return null;
      }
      return JSON.parse(item);
    },
    clear() {
      localStorage.removeItem(BIBLE_STUDY_FORM_TOKEN);
    },
  };
}
